import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateIFrameId } from '../../modules/iFrameId';
import WindowEventListener from '../WindowEventListener';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class SetIFrameId extends Component {
  receiveMessage = ({ origin, data: { type, payload } }) => {
    const { dispatch } = this.props;
    const matchURL = /https?:\/\/+([a-z])*\.*([a-z])*\.*(isf)+\.*[io]*(com)*/;

    if (type === 'SET_IFRAME_ID_REQUEST') {
      if (origin.match(matchURL) && payload) {
        dispatch(updateIFrameId(payload));
      }
    }
  }

  render() {
    return <WindowEventListener event="message" onEvent={this.receiveMessage} />;
  }
}

SetIFrameId.propTypes = propTypes;

export default connect()(SetIFrameId);
